// Fixes bug re removing conditional text components' inner components when editing the other text around it
export function onDisableRte(editor) {
  const conditionalComponents = (editor.getSelected().components().filter((component) => {
    return component.attributes.type == 'conditional-text'
  }))

  conditionalComponents.forEach((component) => {
    component.components(component.attributes.conditionCode)
  })
}